import Auth from 'live/services/authorization'

export function canManageAggregations() {
    return Auth.Permission.isAdmin || Auth.Permission.SUPER_USER || Auth.Permission.MANAGE_ASSET_AGGREGATIONS
}

export function canViewAggregations() {
    return canManageAggregations() || Auth.Permission.VIEW_ASSET_AGGREGATIONS
}
